import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {CioTemplatePreview, ReachTemplateContentChannel} from "./types";

export type CioSource = "cio_studio" | "cio_regular";
export type CioSyncTarget = "media" | "landing_page";

export type FetchCioTemplateVariables = {
  source: CioSource;
  source_link: string;
  content_channel: ReachTemplateContentChannel;
  sync_target?: CioSyncTarget;
};

const fetchCioTemplate = async (variables: FetchCioTemplateVariables): Promise<CioTemplatePreview> => {
  const response = await axiosReachInstance.post<
    CioTemplatePreview,
    AxiosResponse<CioTemplatePreview>,
    FetchCioTemplateVariables
  >("/templates/cio", variables);
  return response.data;
};

export const useFetchCioTemplate = (
  options?: BaseMutationOptions<CioTemplatePreview, FetchCioTemplateVariables>
): BaseUseMutationResult<CioTemplatePreview, FetchCioTemplateVariables> =>
  useBaseMutation<CioTemplatePreview, FetchCioTemplateVariables>(fetchCioTemplate, options);
